module.exports = __webpack_public_path__ + "media/images/faramia/transport_thumbnail-c9f8a8018f05f4160344412f0827e1a5.png";